var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('g',{staticClass:"country",class:{ active: _vm.isActive, selected: _vm.isSelected },attrs:{"id":_vm.countryCode},domProps:{"innerHTML":_vm._s(_vm.paths)},on:{"click":_vm.toggleActive}})}
var staticRenderFns = []

export { render, staticRenderFns }